module.exports = __webpack_public_path__ + "img/template.06fc458e.svg";